var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91667 8L5.95833 3.625L8 8M4.5 6.83333H7.41667M1 2.01928C1.77404 1.92296 2.55332 1.87477 3.33333 1.875M3.33333 1.875C3.76889 1.875 4.20172 1.88978 4.62989 1.91933M3.33333 1.875V1M4.62989 1.91933C4.17956 3.97811 2.82389 5.69778 1 6.63967M4.62989 1.91933C4.97635 1.94292 5.32208 1.97625 5.66667 2.01928M3.88206 5.32289C3.24426 4.67447 2.73877 3.90811 2.39378 3.06656",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageDark);
export default __webpack_public_path__ + "static/media/language_dark.e01aa96f2e4d66b50648558a7cc92585.svg";
export { ForwardRef as ReactComponent };